import React from 'react';
import { connect } from 'react-redux';

import Main from '../Main';

class AgentPortal extends React.PureComponent {
  render() {
    const { translationSites } = this.props;

    return <Main site={translationSites.agent} siteName="Agent" />;
  }
}

const mapStateToProps = (store) => ({
  translationSites: store.translations.translationSites,
});

export default connect(mapStateToProps)(AgentPortal);
